import React from 'react'

import { IHomeType, IPageType } from '@/types'

export const HeroSection: React.FC<IPageType<IHomeType>> = ({ template }) => {
  return (
    <div className="cover">
      <h1 className="blue-color">{template.page_title}</h1>
      <div></div>
    </div>
  )
}
